export const SUPPORT_ENABLED_CHANGE_EVENT = 'imgcloud:support-enabled-change';

const SUPPORT_ENABLED_GLOBAL = '__IMG_CLOUD_SUPPORT_ENABLED__';

export const setCustomerServiceEnabled = (enabled: boolean) => {
  (window as any)[SUPPORT_ENABLED_GLOBAL] = enabled;
  window.dispatchEvent(new CustomEvent(SUPPORT_ENABLED_CHANGE_EVENT, { detail: { enabled } }));
};

export const isCustomerServiceEnabledSync = () =>
  (window as any)[SUPPORT_ENABLED_GLOBAL] === true;
